import React, { useState } from 'react';
import Modal from './Modal.tsx';
import { ShieldCheck, Loader2 } from 'lucide-react';
import axios from '../utils/axios.ts';

interface DisbursementOtpModalProps {
  isOpen: boolean;
  onClose: () => void;
  disbursementId: number | null;
  otpExpiresAt: string | null;
  onSuccess: () => void;
}

export default function DisbursementOtpModal({ isOpen, onClose, disbursementId, otpExpiresAt, onSuccess }: DisbursementOtpModalProps) {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await axios.post(`/disbursements/${disbursementId}/verify-otp`, { otp });
      if (res.data.success) {
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
          onSuccess();
          onClose();
        }, 1500);
      } else {
        setError(res.data.message || 'Failed to verify OTP');
      }
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Failed to verify OTP');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={<span className="flex items-center"><ShieldCheck className="w-6 h-6 text-green-600 mr-2" />Enter OTP</span>}
      footer={
        <>
          <button type="button" onClick={onClose} className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300">Cancel</button>
          <button type="submit" form="otp-form" disabled={loading || otp.length !== 6} className="px-4 py-2 rounded bg-green-600 text-white hover:bg-green-700 flex items-center">
            {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Verify OTP
          </button>
        </>
      }
    >
      <p className="mb-4 text-gray-600 text-sm">
        Enter the 6-digit code sent to your WhatsApp. <br />
        {otpExpiresAt && <span className="text-xs text-gray-400">Expires at: {new Date(otpExpiresAt).toLocaleTimeString()}</span>}
      </p>
      <form id="otp-form" onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="otp"
          value={otp}
          onChange={e => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
          className="w-full border rounded px-3 py-2 text-center text-lg tracking-widest"
          placeholder="------"
          maxLength={6}
          required
          autoFocus
        />
        {error && <div className="text-red-600 text-sm">{error}</div>}
        {success && <div className="text-green-600 text-sm">OTP verified! Disbursement will be processed.</div>}
      </form>
    </Modal>
  );
} 